import { api } from './client';

export interface SystemConfig {
  configKey: string;
  cadenceType: 'sprint' | 'monthly';
  currentPeriod: string;
}

export async function getSystemConfig(): Promise<SystemConfig> {
  const r = await api.get<SystemConfig>('/system/config');
  return r.data;
}
